import { createSlice } from '@reduxjs/toolkit';

const invitationsSlice = createSlice({
    name: 'invitations',
    initialState: {
        activity: [],
        totalRecords: 0,
    },
    reducers: {
        setInvitations: (state, action) => {
            const { activity: invitations, createdAt = 0 } = action.payload;
            if (createdAt === 0) {
                state.activity = invitations || [];
            } else {
                invitations.forEach(invitation => {
                    const existingIndex = state.activity.findIndex(item => item.activityId === invitation.activityId);
                    if (existingIndex !== -1) {
                        state.activity[existingIndex] = { ...state.activity[existingIndex], ...invitation };
                    } else {
                        state.activity.push(invitation);
                    }
                });
            }
        },
        removeInvitationsByUserIds: (state, action) => {
            const { channelId, userIds = [] } = action.payload || {};
            if (!channelId || !Array.isArray(userIds) || userIds.length === 0 || state.activity.length === 0) return;

            const userIdSet = new Set(userIds);

            for (let i = state.activity.length - 1; i >= 0; i--) {
                const item = state.activity[i];
                const isPending = item?.status?.toUpperCase() === 'PENDING';
                if (!isPending) continue;

                const sameChannel = item?.channelDetails?.channelId === channelId || item?.channelId === channelId;
                if (!sameChannel) continue;
                const initiatorId = item?.initiatedBy?.userId;
                const hasUserOverlap = initiatorId && userIdSet.has(initiatorId);

                if (hasUserOverlap) {
                    state.activity.splice(i, 1);
                }
            }
        },
        removeInvitationsByUserId: (state, action) => {
            const { channelId, userId } = action.payload || {};
            if (!channelId || !userId || state.activity.length === 0) return;

            for (let i = state.activity.length - 1; i >= 0; i--) {
                const item = state.activity[i];
                const isPending = item?.status?.toUpperCase() === 'PENDING';
                if (!isPending) continue;

                const sameChannel = item?.channelDetails?.channelId === channelId || item?.channelId === channelId;
                if (!sameChannel) continue;

                const memberId = item?.member?.userId;
                if (memberId === userId) {
                    state.activity.splice(i, 1);
                }
            }
        },
        clearInvitations: state => {
            state.activity = [];
        },
        updateInvitation: (state, action) => {
            const updated = action.payload;
            const index = state.activity.findIndex(item => item.activityId === updated.activityId);
            if (index !== -1) {
                const originalItem = state.activity[index];
                state.activity.splice(index, 1);
                state.activity.unshift({ ...originalItem, ...updated });
            } else {
                state.activity.unshift(updated);
            }
        },
        updateMultipleInvitations: (state, action) => {
            const updates = action.payload;
            updates.forEach(update => {
                const index = state.activity.findIndex(item => item.activityId === update.activityId);
                if (index !== -1) {
                    state.activity[index] = { ...state.activity[index], ...update };
                }
            });
        },
        setTotalRecords: (state, action) => {
            state.totalRecords = action.payload;
        },
        updateInvitationCount: (state, action) => {
            const { status } = action.payload;
            if (status === 'PENDING') {
                state.totalRecords += 1;
            } else {
                state.totalRecords = Math.max(0, state.totalRecords - 1);
            }
        },
        removeInvitationsByChannelId: (state, action) => {
            const { channelId } = action.payload || {};
            if (!channelId || state.activity.length === 0) return;
            state.activity = state.activity.filter(item => item.channelId !== channelId);
        },
    },
});

export const {
    setInvitations,
    clearInvitations,
    updateInvitation,
    updateMultipleInvitations,
    removeInvitationsByUserIds,
    removeInvitationsByUserId,
    setTotalRecords,
    updateInvitationCount,
    removeInvitationsByChannelId,
} = invitationsSlice.actions;

export default invitationsSlice.reducer;
